import { render, staticRenderFns } from "./Section6.vue?vue&type=template&id=c7ba35a8&"
import script from "./Section6.vue?vue&type=script&lang=js&"
export * from "./Section6.vue?vue&type=script&lang=js&"
import style0 from "./Section6.vue?vue&type=style&index=0&id=c7ba35a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports